//Episerver library
import AppConfig from '@episerver/spa-core/AppConfig';
import stageConfig from 'app/StageConfig';

//Referenced components for configuration
import DomainInitializableModule from 'app/utilities/domain/initializable';
import MoseyLoader from 'app/Components/Shared/MoseyLoader';
import CellcomLayout from 'app/Components/Shared/CellcomLayout';
import CallBackInitializable from 'app/Components/Block/CallBackBlock/initializable';
import StandAlonePurchaseSaleInitializable from 'app/Components/Block/StandAlonePurchaseSaleBlock/initializable';
import HeaderInitializableModule from '../src/Components/Block/HeaderMainBlock/initializable';
import TransactionSummaryInitializable from 'app/Components/Page/TransactionSummaryPage/initializable';
import ChoosingOptionOfServiceInitializable from './Components/Block/SelfCareNavBarChoiceBoxModelBlock/initializable';
import PopUpContainerInitializa from 'app/Components/Shared/PopUpContainer/initializable';
import AddressFrmInitializable from 'app/Components/Shared/AddressFrm/initializable';
import OTPVerifyCodeInitializable from 'app/Components/Block/SaleBlock/OTPVerifyCode/initializable';
import OTPVerifyPhoneInitializable from 'app/Components/Block/SaleBlock/OTPVerifyPhone/initializable';
import SetUpDeliveriesInitializable from 'app/Components/Shared/SetUpDeliveries/initializable';
import TechnicianArrivalTimeInitializable from 'app/Components/Block/SaleBlock/TechnicianArrivalTime/initializable';
import IBCTechnicianArrivalTimeInitializable from 'app/Components/Block/SaleBlock/IBCTechnicianArrivalTime/initializable';
import ChoseNewOrExistingCellNumInitializable from 'app/Components/Block/SaleBlock/ChoseNewOrExistingCellNum/initializable';
import ChooseCellularServicesInitializable from 'app/Components/Block/SaleBlock/ChooseCellularServices/initializable';
import PaymentFormInitializable from 'app/Components/Block/SaleBlock/Payment/initializable';
import BankPaymentItializableModule from 'app/Components/Block/UpdatePaymentMethodBlock/BankPaymentMethod/initializable';
import SaleInitializable from 'app/Components/Block/SaleBlock/initializable';
import PersonalInfoInitializable from 'app/Components/Block/SaleBlock/PersonalInfo/initializable';
import CustomerEmailInitializable from 'app/Components/Block/SaleBlock/CustomerEmail/initializable';
import UserAddressInitializable from 'app/Components/Block/SaleBlock/UserAddress/initializable';
import OrderSuccessInitializable from 'app/Components/Block/SaleBlock/OrderSuccess/initializable';
import HeaderSearchInitializable from 'app/Components/Shared/HeaderSearch/initializable';
import AlmostDoneInitializable from 'app/Components/Block/SaleBlock/AlmostDone/initializable';
import UpdatePaymentInitializable from 'app/Components/Block/UpdatePaymentMethodBlock/initializable';
import LoaderInitializable from 'app/Components/Shared/Loader/initializable';
import authenticationMiddleware from './middleware/authentication';
import reportMiddleware from './middleware/report';
import tagManagerMiddleware from './middleware/tagManager';
import networkMiddleware from './middleware/network';
import analyticsMiddleware from './middleware/analytics';
import chatMiddleware from './middleware/chat';
import AppInitInitializableModule from './utilities/initApp/appInitInitializableModule';
import AuthenticationInitializableModule from './utilities/authentication/authenticationInitializableModule';
import SaleJetInitializable from 'app/Components/Block/SaleJetBlock/initializable';
import {loadStateIfNeeded, saveState} from './utilities/stateUtils';
import PersonalAreaInitializable from 'app/Components/Block/PersonalAreaInvoicesBlock/initializable';
import ChangePricePlanInitializable from 'app/Components/Block/ChangePricePlanBlock/initializable';
import SelfCareSuccessMsgInitializable from 'app/Components/Block/SelfCareSuccessMsgBlock/initializable';
import WelcomeInitializableModule from 'app/Components/Block/WelcomeBlock/initializable';
import DisconnectServicesInitializable from 'app/Components/Block/DisconnectServicesBlock/initializable';
import SaleProductsInitializable from 'app/Components/Block/SaleBlock/SaleProducts/initializable';
import SupportedTVItializableModule from 'app/Components/Block/SaleBlock/SupportedTV/initializable';
import DebtPaymentInitializableModule from 'app/Components/Block/DebtPaymentBlock/initializable';
import DebtAndUpdatePaymentInitializableModule from 'app/Components/Block/DebtAndUpdatePaymentBlock/initializable';
import TvActivationCodeRecoveryInitializable from 'app/Components/Block/TvActivationCodeRecoveryBlock/initializable';
import cellularPackageInitializable from 'app/Components/Block/SaleBlock/CellularPackage/initializable';
import IsIBCInternetCustomeritializableModule from 'app/Components/Block/SaleBlock/IsIBCInternetCustomer/initializable';
import newCellNumberSuccessitializableModule from 'app/Components/Block/SaleBlock/NewCellNumberSuccess/initializable';
import PortalsInitializableModule from './Components/Block/PortalsBlock/initializable';
import FiberProductCarditializableModule from 'app/Components/Block/SaleBlock/FiberUpgrades/FiberProductCard/initializable';
import LeadInitializableModule from 'app/Components/Block/LeadBlock/initializable';
import ExtendedLeadInitializableModule from 'app/Components/Block/ExtendedLeadBlock/initializable';
import RouterActivationWizardInitializable from 'app/Components/Block/RouterActivationWizardBlock/Initializable';
import RedirectBoxInitializableModule from 'app/Components/Block/RedirectToUrlBlock/initializable';
import UpdateDeliverySlotHolderItializableModule from 'app/Components/Block/UpdateDeliverySlotBlock/UpdateDeliverySlotHolder/initializable';
import UpdateDeliverySlotItializableModule from 'app/Components/Block/UpdateDeliverySlotBlock/UpdateDeliverySlot/initializable';
import UpdateBusinessDeliverySlotInitializableModule from 'app/Components/Block/IMEIDeviceRepairBlock/UpdateBusinessDeliverySlot/initializable';
import PaymentCGitializableModule from 'app/Components/Block/SaleBlock/PaymentCG/initializable';
import RoutingInitializableModule from 'app/utilities/routing/initializable';
import StateHistoryInitializableModule from 'app/utilities/stateHistory/initializable';
import stateHistoryMiddleware from './middleware/stateHistory';
import CreditGuardResponseModule from 'app/Components/Block/CreditGuardBlock/initializable';
import CellcomAbroadInitializableModule from 'app/Components/Block/CellcomAbroadLobbyBlock/initializable';
import CellularSurfingUseDetailsModule from 'app/Components/Block/CellularSurfingUseDetailsBlock/initializable';
import SubscribersListModule from 'app/Components/Shared/SubscribersList/initializable';
import TabsContainerInitializableModule from 'app/Components/Block/TabsContainerBlock/initializable';
import GenericVasInitializableModule from 'app/Components/Block/GenericVASBlock/initializable';
import IdfSaleInitializableModule from 'app/Components/Block/IdfSaleBlock/initializable';
import SaleInitializableModule from 'app/Components/Page/SelfCarePage/initializable';
import AbroadPerfectPackageInitializableModule from 'app/Components/Block/AbroadPerfectPackageBlock/initializable';
import SimActivationPageReducer from 'app/Components/Block/SaleBlock/SimActivation/initializable';
import PremiumPackagesHolderItializableModule from 'app/Components/Block/PremiumPackagesBlock/PremiumPackagesHolder/initializable';
import LawClassActionInitializableModule from 'app/Components/Block/LawClassActionBlock/initializable';
import CallBackLiteInitializableModule from 'app/Components/Shared/CallBackLite/initializable';
import FundialInitializableModule from 'app/Components/Page/FundialPage/initializable';
import OtpInitializable from 'app/Components/Shared/Otp/initializable';
import CellcomEnergyInitializable from 'app/Components/Block/CellcomEnergyBlock/initializable';
import SelfCreatedTechnicianVisitInitializableModule from 'app/Components/Block/SelfCreatedTechnicianVisitBlock/initializable';
import TechnicianUpdatesInitializableModule from 'app/Components/Block/TechnicianUpdatesBlock/initializable';
import BenefitCustomerBlockInitializableModule from 'app/Components/Block/BenefitCustomerBlock/initializable';
import PopupBenefitInitializableModule from 'app/Components/Block/PopupBenefitBlock/initializable';
import UpdateContactAndAccountDetailsModule from 'app/Components/Block/UpdateContactAndAccountDetailsBlock/initializable';
import CheckFiberInfrastructureInitializableModule from 'app/Components/Block/CheckFiberInfrastructureBlock/initializable';
import OtpAuthenticationModule from 'app/Components/Shared/OtpAuthentication/initializable';
import SalePackagesInitializableModule from 'app/Components/Block/SalePackagesBlock/initializable';
import EsimInitializableModule from 'app/Components/Block/EsimGeneralBlock/initializable';
import OTPInitializableModule from 'app/Components/Shared/OtpAuthentication/initializable';
import movingInitializable from 'app/Components/Block/MovingApartmentBlock/initializable';
import productsAndServicesInitializableModule from 'app/Components/Block/SelfCareProductsAndServicesBlock/initializable';
import contactUsInitializableModule from 'app/Components/Shared/SaleHeader/ContactUs/initializable';
import TouristESimInitializable from 'app/Components/Block/TouristESimBlock/initializable';
import CoreProductActionsInitializableModule from 'app/Components/Block/CoreProductActionsBlock/initializable';
import IMEIDeviceRepairInitializableModule from 'app/Components/Block/IMEIDeviceRepairBlock/initializable';
import PremiumPackagesCatalogInitializableModule from 'app/Components/Block/PremiumPackagesCatalogBlock/initializable';
import SelfCareUploadFileModule from 'app/Components/Block/SelfCareUploadFileBlock/initializable';
import ManufacturerWarrantyStatusInitializableModule from 'app/Components/Block/ManufacturerWarrantyStatusBlock/initializable';
import UpdateBusinessDeliverySlotHolderItializableModule from 'app/Components/Block/IMEIDeviceRepairBlock/UpdateBusinessDeliverySlotHolder/initializable';
import DataWarehouseInitializableModule from 'app/Components/Block/DataWarehouseBlock/initializable';
import AddonsBlockInitializableModule from 'app/Components/Block/AddonsBlock/initializable';
import UpdateMailingMethodModule from 'app/Components/Block/UpdateMailingMethodBlock/initializable';
import BusinessReportInitializableModule from 'app/Components/Block/BusinessReportBlock/initializable';
import BitPaymentModule from 'app/Components/Shared/BitPayment/initializable';
import OrganizationPortalModule from 'app/Components/Block/OrganizationPortalBlock/initializable';
import SimReplacementInitializableModule from 'app/Components/Block/SimReplacementBlock/initializable';
import EcommerceOtpInitializableModule from 'app/Components/Block/EcommerceOtpBlock/initializable';
import CellcomCareersModule from 'app/Components/Page/CellcomCareersPage/initializable';
import ElectricCompanyLeadInitializableModule from 'app/Components/Block/ElectricCompanyLeadBlock/initializable';
import FamilyMembersCellularSaleInitializableModule from 'app/Components/Block/FamilyMemberCellularSaleBlock/initializable';
import AbroadCallsTroubleshootingWizardInitializableModule from 'app/Components/Block/AbroadCallsTroubleshootingWizardBlock/initializable';
import OccasionalCreditCardInputInitializableModule from 'app/Components/Block/OccasionalCreditCardInputBlock/initializable';
import CouponComponentInitializableModule from 'app/Components/Block/CouponComponentBlock/initializable';
import IDFSurfingPackageExpansionInitializableModule from 'app/Components/Block/IdfSurfingPackageExpansionBlock/initializable';
import IdfNewPlanSignupInitializableModule from 'app/Components/Block/IdfNewPlanSignupBlock/initializable';
import TransferOrganizationAccountInitializableModule from 'app/Components/Block/TransferOrganizationAccountBlock/initializable';
import EnergySaleInitializableModule from 'app/Components/Block/EnergySaleBlock/initializable';
import EsimUpgradeBlockInitializableModule from 'app/Components/Block/EsimUpgradeBlock/initializable';
import EsimQrCodeBlockInitializableModule from 'app/Components/Block/EsimQrCodeBlock/initializable';
import SelfCarePageInitializableModule from 'app/Components/Page/SelfCarePage/initializable';
import OrgUsersManagementModule from 'app/Components/Block/UploadOrgUsersListBlock/initializable';
import SliderLeadInitializableModule from 'app/Components/Block/SliderLeadBlock/initializable';
import PersonalAreaInvoices from 'app/Components/Page/PersonalAreaInvoicesPage/initializable';
import SelfCareInvoiceInitializableModule from 'app/Components/Block/SelfCareInvoicesBlock/initializable';
import AddonsAndUpgradesBlockInitializableModule from 'app/Components/Block/AddonsAndUpgradesBlock/initializable';
import VolteCheckInitializable from 'app/Components/Block/VolteCheckBlock/VolteCheckSliceInitializable';
import ServiceAccessFormInitializableModule from 'app/Components/Shared/ServiceAccessForm/initializable';
import OwnershipTransferInitializableModule from 'app/Components/Block/OwnershipTransferBlock/initializable';
import OwnershipTransferCustomerInitializableModule from 'app/Components/Block/OwnershipTransferCustomerBlock/initializable';
import OwnershipTransferPrivateSellerInitializableModule from 'app/Components/Block/OwnershipTransferPrivateSellerBlock/initializable';
import OwnershipTransferPrivateBuyerInitializableModule from 'app/Components/Block/OwnershipTransferPrivateBuyerBlock/initializable';
import CellularDataOnOffInitializableModule from 'app/Components/Block/CellularDataOnOff/initializable';
import CouponHistoryInitializableModule from 'app/Components/Block/CouponHistory/initializable';
import ServiceAppointmentSchedulerBlock from 'app/Components/Block/ServiceAppointmentSchedulerBlock/initializable';
import RouterSelfInstallSliceInitializableModule from 'app/Components/Block/RouterSelfInstallBlock/initializable';
import ZoneFaultInitializableModule from 'app/Components/Block/ZoneFaultBlock/initializable';
import ConnectionDetailsModule from 'app/Components/Block/ConnectionDetailsBlock/initializable';
import EquipmentListModule from 'app/Components/Page/EquipmentListPage/initializable';
import GenericWizardInitializableModule from 'app/Components/Block/GenericWizardBlock/initializable';
import EquipmentMineModule from 'app/Components/Page/MineEquipmentPage/initializable';
import CouponTermsInitializableModule from 'app/Components/Block/CouponTerms/initializable';
import WifiManagementBlockInitializableModule from 'app/Components/Block/WifiManagementBlock/initializable';
import SpeedTestAndDisconnectionsWizardInitializableModule from 'app/Components/Block/SpeedTestAndDisconnectionsWizardBlock/initializable';
import LocalCellularTroubleshootingWizardInitializableModule from 'app/Components/Block/LocalCellularTroubleshootingWizardBlock/initializable';
import AbroadDataTroubleshootingWizardInitializableModule from 'app/Components/Block/AbroadTroubleshootingWizardBlock/initializable';
import BusinessWorkOrderSystemModule from 'app/Components/Block/BusinessWorkOrderSystem/initializable';
import ChangePhoneNumberInitializableModule from 'app/Components/Block/ChangePhoneNumberBlock/initializable';
import BusinessMonitoringChartsBlock from 'app/Components/Block/BusinessMonitoringChartsBlock/initializable';
import DwhReportManagementInitializableModule from 'app/Components/Block/DwhReportManagementBlock/initializable';
import FunToneBlock from 'app/Components/Block/FuntoneBlock/initializable';
import BusinessClientEsimUpgradeInitializableModule from 'app/Components/Block/BusinessClientEsimUpgradeBlock/initializable';
import BusinessActivateNiudInitializableModule from 'app/Components/Block/BusinessActivateNiudBlock/initializable';
import BusinessCheckNiudStatusInitializableModule from 'app/Components/Block/BusinessCheckNiudStatusBlock/initializable';
import BusinessDashboardInitializableModule from 'app/Components/Block/BusinessDashboardBlock/initializable';
import EnergyReplaceBlockInitializableModule from 'app/Components/Block/EnergyReplaceBlock/initializable';
import VisualIVRInitializableModule from 'app/Components/Block/VisualIVRMenuBlock/initializable';
import LeadContactFormInitializableModule from 'app/Components/Block/LeadContactFormBlock/initializable';
import PersonalPricePlanInitializableModule from 'app/Components/Block/PersonalPricePlanBlock/initializable';
import ProblemDomainSelectionInitializableModule from 'app/Components/Block/ProblemDomainSelectionBlock/initializable';
import StartPageInitializableModule from 'app/Components/Shared/CellcomLayoutPage/initializable';
import StreamingRegistrationInitializableModule from 'app/Components/Block/StreamingRegistrationRedirectionBlock/initializable';
import OperationsAreasInitializableModule from 'app/Components/Block/OperationsAreasBlock/initializable';
import {BaseSiteData, mergeBaseSiteData} from 'app/utilities/baseData/baseData';
import OrgEmployeePageModule from 'app/Components/Page/OrganizationEmloyeePage/initializable';
import OrgEmployeeFamilySalePageModule from 'app/Components/Page/OrgEmployeeFamilySalePage/initializable';

interface CellcomConfig extends AppConfig, BaseSiteData {
  /** Hydrate Config fields from startPage once at app load, unwrapping `.value`. */
  setBaseData: (content: Record<string, unknown> | null | undefined) => void;
  _baseDataReady?: boolean;
  startPageBlock?: string;
  useOldLogin?: boolean;
  apiGwUrl?: string;
  defaultTimeout: number;
  client_id?: string;
  siteScope?: string;
  defaultLoginTemplate?: string;
  errorPageNotFound?: string;
  namespaceToRemove?: any;
  loginUrlTemplate?: string;
  newFullLoginUrl?: string;
  newLoginUrl?: string;
  idfLoginUrlTemplate?: string;
  loginType?: string;
  logoutPage?: string;
  staticWebSiteUrl: string;
  loginApiUrl: string;
  creditCardTokenUrl: string;
  environmentCookieDomain?: string;
  captchaSiteKey: string;
  iosTvApplicationUrl: string;
  androidTvApplicationUrl: string;
  androidTvApplicationMobileUrl: string;
  lobbyUrl: string;
  idfLobbyUrl: string;
  disconnectCellularUrl: string;
  businessLobbyUrl: string;
  idfCellcomCenter: string;
  idfCellcomCenterFullNumber: string;
  verifyCodeAttemptsLimit: number;
  analyticsTrackingId: string;
  meshUpgradeCost: number;
  energyCallCenter: string;
  isTimeSlotsGetFromClick: boolean;
  cellcomServiceCenters: string;
  cgShowIdNumber: string;
  firstTechnicianRange: number;
  whatsAppSale: string;
  whatsAppSelfCare: string;
  whatsAppTechnicalService: string;
  affiliateExpiryTimeInDays: number;
  customerTrackingExpiryTimeInDays: number;
  simActivationCodePrefix: string;
  numberCallCenterAbroad: string;
  maximumConverters: number;
  familyBundleMaxAdditionalMembers?: number;
  cooperationTermsLink: string;
  abroadInsuranceLink: string;
  ecommerceLink: string;
  cellcomShopLink: string;
  advertisingInfoLink: string;
  otpErrorPage: string;
  cooperationPrivacyPolicyLink: string;
  termsUrl: string;
  defaultChatBubbleGroup: string;
  hideChatBox: string;
  imgMainBtnBubbleChatOpen: string;
  imgMainBtnBubbleChatClose: string;
  MezaheBituahC: string;
  MezaheBituah: string;
  thirdPartyDefaulText: string;
  thirdPartyExtendedText: string;
  thirdPartyBottomText: string;
  thirdPartyCloseTextButton: string;
  thirdPartyExpandButtonText: string;
  primaryEmailText: string;
  primaryEmailMoreInfoUrl: string;
  PrimaryEmailMoreInfoText: string;
  organizationPortalUrlActivate: string;
  organizationPortalUrlUpgrade: string;

  receivingAdTitle: string;
  receivingAdText: string;
  moreInfoLinkText: string;
  moreInfoLink: string;

  potentialCustomerDefaulText: string;
  potentialCustomerTooltipText: string;
  potentialCustomerBottomText: string;
  potentialCustomerTextButton: string;

  idfSaleUrl: string;
  idfHomePageUrl: string;
  idfLoginUrl: string;
  abroadUrl: string;
  businessLandPageUrl: string;
  internetSaleLink: string;
  idfWhatsAppLink: string;
  protectedCookies: string[];
  protectedCookiesPatterns: string[];

  selfCareInternetLink: string;
  selfCareTvLink: string;
  selfCareCellularLink: string;
  selfCareElectricityLink: string;
  selfCareAbroadLink: string;
  payDebtLink: string;
  updatePaymentMethodLink: string;
  joinCellularServiceLink: string;
  loginPageLegalText: string;
  redirectToHboUrl: string;
  redirectToDisneyUrl: string;
}

//Website configuration
const Config: CellcomConfig = {
  ...stageConfig,

  // SHARED
  siteScope: 'PRIVATE_WEBSITE',
  creditCardTokenUrl: 'https://credit.cellcom.co.il:9090/AuthCreditCard',
  enableDebug: true, //Will be forced to false if build with a "production" environment
  autoExpandRequests: true, //Should all properties be expanded by default
  defaultTimeout: 50000,

  //Connection details
  basePath: process.env.WEB_PATH,
  epiBaseUrl: process.env.EPI_URL,
  defaultLanguage: '',
  namespaceToRemove: ['ns0:', 'env:', 'std:', 'ns1:'],

  // Timeslots interface
  isTimeSlotsGetFromClick: false,

  //Site layout
  layout: CellcomLayout,

  //Limits
  verifyCodeAttemptsLimit: 10,
  meshUpgradeCost: 10,
  affiliateExpiryTimeInDays: 7,
  customerTrackingExpiryTimeInDays: 365,
  simActivationCodePrefix: '89972020',
  maximumConverters: 5,
  familyBundleMaxAdditionalMembers: 5,

  //Spinner
  enableSpinner: false,
  spinner: MoseyLoader,
  spinnerTimeout: 250,

  // Runtime config, keep empty values will be placed by API at start up
  lobbyUrl: '/selfcare/lobby',
  idfLobbyUrl: '/idfhomepage',
  businessLobbyUrl: '',
  disconnectCellularUrl: 'https://www.netek.co.il/?target=_blank',
  iosTvApplicationUrl: 'https://itunes.apple.com/il/app/tv-slqwm/id642315912?mt=8',
  androidTvApplicationUrl: 'https://play.google.com/store/apps/details?id=com.cellcom.cellcom_tv',
  androidTvApplicationMobileUrl: 'https://play.google.com/store/apps/details?id=com.cellcom.cellcomtv',
  cellcomServiceCenters: 'https://cellcom-digital-static.dmznt.corp.cellcom.co.il/production/Private/contact_us/centers/',
  numberCallCenterAbroad: '+972-529986919',
  cooperationTermsLink: '',
  abroadInsuranceLink: '',
  ecommerceLink: '',
  cellcomShopLink: '',
  advertisingInfoLink: '',
  otpErrorPage: '',
  termsUrl: '',
  defaultChatBubbleGroup: '',
  hideChatBox: '',
  imgMainBtnBubbleChatOpen: '',
  imgMainBtnBubbleChatClose: '',
  cooperationPrivacyPolicyLink: '',
  idfCellcomCenter: '',
  thirdPartyDefaulText: '',
  thirdPartyExtendedText: '',
  thirdPartyCloseTextButton: '',
  thirdPartyBottomText: '',
  thirdPartyExpandButtonText: '',
  primaryEmailText: '',
  primaryEmailMoreInfoUrl: '',
  PrimaryEmailMoreInfoText: '',
  organizationPortalUrlActivate: '',
  organizationPortalUrlUpgrade: '',

  receivingAdTitle: '',
  receivingAdText: '',
  moreInfoLinkText: '',
  moreInfoLink: '',

  potentialCustomerDefaulText: '',
  potentialCustomerTooltipText: '',
  potentialCustomerBottomText: '',
  potentialCustomerTextButton: '',
  newLoginUrl: '',
  idfSaleUrl: '',
  idfHomePageUrl: '',
  idfLoginUrl: '',
  businessLandPageUrl: '',
  internetSaleLink: '',
  abroadUrl: '',
  // Overridden by GlobalConfig from EPI Server
  useOldLogin: false,
  defaultLoginTemplate: 'Lobby',
  logoutPage: 'logout',
  errorPageNotFound: '/404/',
  cgShowIdNumber: 'none',
  firstTechnicianRange: 5,
  whatsAppSale: '',
  whatsAppSelfCare: '',
  whatsAppTechnicalService: '',
  idfCellcomCenterFullNumber: '',
  idfWhatsAppLink: '',
  protectedCookies: [],
  protectedCookiesPatterns: [],
  
  selfCareInternetLink: '',
  selfCareTvLink: '',
  selfCareCellularLink: '',
  selfCareElectricityLink: '',
  selfCareAbroadLink: '',
  payDebtLink: '',
  updatePaymentMethodLink: '',
  joinCellularServiceLink: '',
  loginPageLegalText: '',
  redirectToHboUrl: '',
  redirectToDisneyUrl: '',
  mainLogo: '',
  siteLogo: '',
  // Base site fields from startPage (hydrated once at app load via CmsSite → setBaseData)
  brand_Name_HE: 'סלקום',
  brand_Name_EN: 'Cellcom',
  energyCallCenter: '2266*',
  financeCallNumber1: '*147',
  financeCallNumber2: '*5147',
  businessCallNumber: '*234',
  technicalSupportPhone: '*3123',
  _baseDataReady: false,
  setBaseData(content) {
    if (this._baseDataReady) return;
    mergeBaseSiteData(this as unknown as Record<string, unknown>, content);
    this._baseDataReady = true;
  },

  //Content area configuration
  contentArea: {
    displayOptions: {
      'displaymode-screen': 'screen v-100',
      'displaymode-half': 'col-12 col-md-6',
      'displaymode-one-third': 'col-12 col-md-4',
    },
    defaultRowClass: 'row no-gutters',
    defaultBlockClass: 'col-12',
    containerBreakBlockClass: 'screen',
  },

  //Preloading of components
  preLoadComponents: [
    'Media/Image/ImageMediaData',
    'Block/Media/Image/ImageMediaData',
    'Block/MenuItemBlock',
    'Block/TextBlock',
    'Block/BreadcrumbBlock',
    'Page/CmsHomePage',
    'Page/LandingPage',
    'Page/StandardPage',
    'Page/BlogListPage',
  ],

  modules: [
    new DomainInitializableModule(),
    new RouterSelfInstallSliceInitializableModule(),
    new RoutingInitializableModule(),
    new StateHistoryInitializableModule(),
    new AppInitInitializableModule(),
    new AuthenticationInitializableModule(),
    new StartPageInitializableModule(),
    new SaleJetInitializable(),
    new CallBackInitializable(),
    new TransactionSummaryInitializable(),
    new StandAlonePurchaseSaleInitializable(),
    new ChoosingOptionOfServiceInitializable(),
    new AddressFrmInitializable(),
    new OTPVerifyCodeInitializable(),
    new OTPVerifyPhoneInitializable(),
    new SetUpDeliveriesInitializable(),
    new TechnicianArrivalTimeInitializable(),
    new IBCTechnicianArrivalTimeInitializable(),
    new ChoseNewOrExistingCellNumInitializable(),
    new ChooseCellularServicesInitializable(),
    new PopUpContainerInitializa(),
    new SaleInitializable(),
    new PaymentFormInitializable(),
    new BankPaymentItializableModule(),
    new PersonalInfoInitializable(),
    new CustomerEmailInitializable(),
    new PersonalAreaInitializable(),
    new PopUpContainerInitializa(),
    new UpdatePaymentInitializable(),
    new ChangePricePlanInitializable(),
    new SelfCareSuccessMsgInitializable(),
    new UserAddressInitializable(),
    new OrderSuccessInitializable(),
    new HeaderSearchInitializable(),
    new AlmostDoneInitializable(),
    new LoaderInitializable(),
    new WelcomeInitializableModule(),
    new DisconnectServicesInitializable(),
    new SaleProductsInitializable(),
    new SupportedTVItializableModule(),
    new cellularPackageInitializable(),
    new TvActivationCodeRecoveryInitializable(),
    new DebtPaymentInitializableModule(),
    new DebtAndUpdatePaymentInitializableModule(),
    new IsIBCInternetCustomeritializableModule(),
    new HeaderInitializableModule(),
    new newCellNumberSuccessitializableModule(),
    new PortalsInitializableModule(),
    new LeadInitializableModule(),
    new RouterActivationWizardInitializable(),
    new FiberProductCarditializableModule(),
    new RedirectBoxInitializableModule(),
    new ExtendedLeadInitializableModule(),
    new UpdateDeliverySlotHolderItializableModule(),
    new UpdateBusinessDeliverySlotHolderItializableModule(),
    new UpdateDeliverySlotItializableModule(),
    new UpdateBusinessDeliverySlotInitializableModule(),
    new PaymentCGitializableModule(),
    new CreditGuardResponseModule(),
    new CellcomAbroadInitializableModule(),
    new CellularSurfingUseDetailsModule(),
    new SubscribersListModule(),
    new GenericVasInitializableModule(),
    new IdfSaleInitializableModule(),
    new SaleInitializableModule(),
    new TabsContainerInitializableModule(),
    new AbroadPerfectPackageInitializableModule(),
    new PremiumPackagesHolderItializableModule(),
    new SimActivationPageReducer(),
    new LawClassActionInitializableModule(),
    new CallBackLiteInitializableModule(),
    new FundialInitializableModule(),
    new OtpInitializable(),
    new CellcomEnergyInitializable(),
    new SelfCreatedTechnicianVisitInitializableModule(),
    new TechnicianUpdatesInitializableModule(),
    new PopupBenefitInitializableModule(),
    new BenefitCustomerBlockInitializableModule(),
    new UpdateContactAndAccountDetailsModule(),
    new CheckFiberInfrastructureInitializableModule(),
    new TechnicianUpdatesInitializableModule(),
    new OtpAuthenticationModule(),
    new SalePackagesInitializableModule(),
    new EsimInitializableModule(),
    new OTPInitializableModule(),
    new movingInitializable(),
    new EcommerceOtpInitializableModule(),
    new productsAndServicesInitializableModule(),
    new contactUsInitializableModule(),
    new TouristESimInitializable(),
    new CoreProductActionsInitializableModule(),
    new IMEIDeviceRepairInitializableModule(),
    new PremiumPackagesCatalogInitializableModule(),
    new SelfCareUploadFileModule(),
    new ManufacturerWarrantyStatusInitializableModule(),
    new DataWarehouseInitializableModule(),
    new AddonsBlockInitializableModule(),
    new UpdateMailingMethodModule(),
    new BitPaymentModule(),
    new BusinessReportInitializableModule(),
    new SimReplacementInitializableModule(),
    new CellcomCareersModule(),
    new OrganizationPortalModule(),
    new OrgEmployeePageModule(),
    new OrgEmployeeFamilySalePageModule(),
    new ElectricCompanyLeadInitializableModule(),
    new OccasionalCreditCardInputInitializableModule(),
    new CouponComponentInitializableModule(),
    new FamilyMembersCellularSaleInitializableModule(),
    new AbroadCallsTroubleshootingWizardInitializableModule(),
    new IDFSurfingPackageExpansionInitializableModule(),
    new IdfNewPlanSignupInitializableModule(),
    new TransferOrganizationAccountInitializableModule(),
    new EnergySaleInitializableModule(),
    new EsimUpgradeBlockInitializableModule(),
    new EsimQrCodeBlockInitializableModule(),
    new SelfCarePageInitializableModule(),
    new OrgUsersManagementModule(),
    new SliderLeadInitializableModule(),
    new PersonalAreaInvoices(),
    new SelfCareInvoiceInitializableModule(),
    new AddonsAndUpgradesBlockInitializableModule(),
    new VolteCheckInitializable(),
    new ServiceAccessFormInitializableModule(),
    new OwnershipTransferInitializableModule(),
    new OwnershipTransferCustomerInitializableModule(),
    new OwnershipTransferPrivateSellerInitializableModule(),
    new OwnershipTransferPrivateBuyerInitializableModule(),
    new CellularDataOnOffInitializableModule(),
    new ServiceAppointmentSchedulerBlock(),
    new ZoneFaultInitializableModule(),
    new ConnectionDetailsModule(),
    new CouponHistoryInitializableModule(),
    new EquipmentListModule(),
    new GenericWizardInitializableModule(),
    new EquipmentMineModule(),
    new CouponTermsInitializableModule(),
    new WifiManagementBlockInitializableModule(),
    new SpeedTestAndDisconnectionsWizardInitializableModule(),
    new LocalCellularTroubleshootingWizardInitializableModule(),
    new AbroadDataTroubleshootingWizardInitializableModule(),
    new WifiManagementBlockInitializableModule(),
    new BusinessWorkOrderSystemModule(),
    new BusinessMonitoringChartsBlock(),
    new DwhReportManagementInitializableModule(),
    new ChangePhoneNumberInitializableModule(),
    new FunToneBlock(),
    new BusinessClientEsimUpgradeInitializableModule(),
    new BusinessActivateNiudInitializableModule(),
    new BusinessCheckNiudStatusInitializableModule(),
    new EnergyReplaceBlockInitializableModule(),
    new BusinessDashboardInitializableModule(),
    new StreamingRegistrationInitializableModule(),
    new VisualIVRInitializableModule(),
    new LeadContactFormInitializableModule(),
    new PersonalPricePlanInitializableModule(),
    new OperationsAreasInitializableModule(),
    new ProblemDomainSelectionInitializableModule(),
  ],

  middleware: [
    stateHistoryMiddleware,
    authenticationMiddleware,
    analyticsMiddleware,
    reportMiddleware,
    tagManagerMiddleware,
    networkMiddleware,
    chatMiddleware,
  ],

  preloadedState: loadStateIfNeeded(),

  stateChangeListeners: [
    (state) => {
      if (state && state.authentication && state.authentication.error && state.authentication.error.errorCode == '403') {
        saveState(state);
      }
    },
  ],

  rootReducer: (allReducers: any) => (state: any, action: any) => {
    if (action.type === 'RESET_APP') state = {...state, ...action.payload};
    if (action.type === 'RESET_APP') state = {...state, ...action.payload};
    if (action.type === 'RESTORE_FROM_HISTORY' && action.payload?.sliceKey) {
      state = {...state, [action.payload.sliceKey]: action.payload.data};
    }

    return allReducers(state, action);
  },
};

declare global {
  interface Window {
    Config: CellcomConfig;
  }
}

if (typeof window !== 'undefined') {
  window.Config = Config;
}

export default Config;
